import { CoreMenu } from "src/@core/types";

export const iNestMenu: CoreMenu[] = [
    {
        id: 'Team-Members',
        title: 'Team Members',
        type: 'collapsible',
        icon: 'employees.svg',
        role: {
            roles: ['employee'],
            right: 'N1002',
        },
        children: [
            {
                id: 'All-Team-Members',
                title: 'All Team Members',
                type: 'item',
                icon: 'employees.svg',
                url: '/i-nest/employees/list/all',
                role: {
                    roles: ['employee'],
                    right: 'N1018',
                },
            },
        ],
    },
    {
        exactMatch: true,
        id: 'Self',
        title: 'Self',
        type: 'collapsible',
        icon: 'profile.svg',
        role: {
            roles: ['employee'],
            right: ['N1001', 'N1003'],
        },
        children: [
            {
                id: 'my-attendance',
                title: 'My Attendance',
                type: 'item',
                icon: 'attendance.svg',
                url: 'i-nest/attendance/self',
                role: {
                    roles: ['employee'],
                    right: 'N1001',
                },
            },
            {
                exactMatch: true,
                id: 'leaves',
                title: 'Leaves',
                type: 'item',
                icon: 'leaves.svg',
                url: 'i-nest/leave-management/leaves',
                role: {
                    roles: ['employee'],
                    right: 'N1003',
                },
            },
        ],
    },
    {
        id: 'Team',
        title: 'Team',
        type: 'collapsible',
        icon: 'my-team.svg',
        role: {
            roles: ['employee'],
            right: ['N1027', 'N1008'],
        },
        children: [
            {
                id: 'Team',
                title: 'Team',
                type: 'item',
                icon: 'my-team.svg',
                url: '/i-nest/employees/list/team',
                role: {
                    roles: ['employee'],
                    right: 'N1027',
                },
            },
            {
                id: 'team-attendance',
                title: 'Team Attendance',
                type: 'item',
                icon: 'team-attendance.svg',
                url: 'i-nest/attendance/team',
                role: {
                    roles: ['employee'],
                    right: 'N1008',
                },
            },
        ],
    },
    {
        exactMatch: true,
        id: 'Leaves',
        title: 'Leaves',
        type: 'collapsible',
        icon: 'leaves.svg',
        role: {
            roles: ['employee'],
            right: ['N1003', 'N1035', 'N1037', 'N1038', 'N1039'],
        },
        children: [
            {
                exactMatch: true,
                id: 'leaves',
                title: 'Leaves',
                type: 'item',
                icon: 'leaves.svg',
                url: 'i-nest/leave-management/leaves',
                role: {
                    roles: ['employee'],
                    right: 'N1003',
                },
            },
            {
                exactMatch: true,
                id: 'all-leaves',
                title: 'All Leaves',
                type: 'item',
                icon: 'all-leaves.svg',
                url: 'i-nest/leave-management/leaves/all',
                role: {
                    roles: ['employee'],
                    right: 'N1035',
                },
            },
            {
                id: 'leaves-approval',
                title: 'Leaves Approval',
                type: 'item',
                icon: 'leave-approval.svg',
                url: 'i-nest/leave-management/approval',
                role: {
                    roles: ['employee'],
                    right: 'N1037',
                },
            },
            {
                id: 'Leave-Quota',
                title: 'Leave Quota',
                type: 'item',
                icon: 'leave-quota.svg',
                url: 'i-nest/leave-management/quota',
                role: {
                    roles: ['employee'],
                    right: 'N1038',
                },
            },
            {
                id: 'Leave-Types',
                title: 'Leave Types',
                type: 'item',
                icon: 'leave-type.svg',
                url: 'i-nest/leave-management/types',
                role: {
                    roles: ['employee'],
                    right: 'N1039',
                },
            },
        ],
    },
    {
        id: 'Broadcast',
        title: 'Broadcast',
        type: 'collapsible',
        icon: 'announcements.svg',
        role: {
            roles: ['employee'],
            right: ['N1004', 'N1000', 'N1005'],
        },
        children: [
            {
                id: 'News',
                title: 'News',
                type: 'item',
                icon: 'news.svg',
                url: 'i-nest/broadcast/news',
                role: {
                    roles: ['employee'],
                    right: 'N1004',
                },
            },
            {
                id: 'Announcements',
                title: 'Announcements',
                type: 'item',
                icon: 'announcements.svg',
                url: 'i-nest/broadcast/announcements',
                role: {
                    roles: ['employee'],
                    right: 'N1000',
                },
            },
            {
                id: 'Posts',
                title: 'Posts',
                type: 'item',
                icon: 'posts.svg',
                url: `i-nest/broadcast/posts`,
                role: {
                    roles: ['employee'],
                    right: 'N1005',
                },
            },
        ],
    },
    {
        id: 'Todo',
        title: 'Todo',
        type: 'item',
        icon: 'TODO.svg',
        url: '/i-nest/todos',
        role: {
            roles: ['employee'],
            right: 'N1009',
        },
    },
    {
        id: 'Task Management',
        title: 'Task Management',
        type: 'item',
        icon: 'task-managemnet.svg',
        url: '/i-nest/task-management',
        role: {
            roles: ['employee'],
            right: 'N1007',
        },
    },
    {
        id: 'iNest-Setup',
        title: 'Setup',
        type: 'collapsible',
        icon: 'settings.svg',
        role: {
            roles: ['employee'],
            right: ['N1006', 'N1462', 'N1372', 'N1631'],
        },
        children: [
            {
                id: 'Startup',
                title: 'Startup',
                type: 'item',
                icon: 'department.svg',
                url: '/i-nest/setup/startup',
                role: {
                    roles: ['employee'],
                    right: 'N1006',
                },
            },
            {
                id: 'Role',
                title: 'Role',
                type: 'item',
                icon: 'roles.svg',
                url: '/i-nest/setup/role',
                role: {
                    roles: ['employee'],
                    right: 'N1462',
                },
            },
            {
                id: 'Designation',
                title: 'Designation',
                type: 'item',
                icon: 'designation.svg',
                url: '/i-nest/setup/designation',
                role: {
                    roles: ['employee'],
                    right: 'N1372',
                },
            },
            {
                id: 'Shift',
                title: 'Shift',
                type: 'item',
                icon: 'shifts.svg',
                url: '/i-nest/setup/shift',
                role: {
                    roles: ['employee'],
                    right: 'N1631',
                },
            },
        ],
    },
    {
        id: 'Events-Management',
        title: 'Event Management',
        type: 'collapsible',
        icon: 'events.svg',
        role: {
            roles: ['employee'],
            right: 'N1309',
        },
        children: [
            {
                exactMatch: true,
                id: 'Event-Calendar',
                title: 'Events',
                type: 'item',
                icon: 'events.svg',
                url: '/i-nest/events',
                role: {
                    roles: ['employee'],
                    right: '',
                },
            },
            {
                exactMatch: true,
                id: 'Event-Attendance',
                title: 'Event Attendance',
                type: 'item',
                icon: 'team-attendance.svg',
                url: '/i-nest/events/attendance',
                role: {
                    roles: ['employee'],
                    right: 'N1356',
                },
            }
        ],
    },
];